import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { BENCHMARKS, BENCH_FACTS, LEGAL_CHECK, MERCHANT_FAQ, TOOLS } from "../../lib/manualKit";

export const Benchmarks = () => (
  <div data-testid="manual-benchmarks">
    <p className="text-xs text-white/45 mb-5" data-testid="benchmarks-disclaimer">Industry estimates. Ranges are compiled from public processor and industry reports and vary by region, processor and product. Use them as context, not guarantees.</p>
    <div className="grid lg:grid-cols-2 gap-6">
      <div className="panel p-5">
        <p className="label-xs">Typical chargeback rate by industry</p>
        <table className="w-full mt-3 text-sm"><tbody>{BENCHMARKS.map(([k, v]) => <tr key={k} className="border-t border-divider"><td className="py-2 text-white/75">{k}</td><td className="py-2 text-right font-mono text-brand">{v}</td></tr>)}</tbody></table>
      </div>
      <div className="space-y-3">{BENCH_FACTS.map(([k, v]) => <div key={k} className="border-l-2 border-brand pl-4"><p className="font-bold text-sm">{k}</p><p className="text-sm text-white/65 mt-1">{v}</p></div>)}</div>
    </div>
  </div>
);

const ToolLink = ({ l, href, note }) => {
  const cls = "text-sm text-white/80 hover:text-brand transition-colors";
  const inner = <>{l}{note && <span className="text-white/40"> · {note}</span>}</>;
  if (href.startsWith("http")) return <a href={href} target="_blank" rel="noreferrer" className={`${cls} inline-flex items-center gap-1.5`}>{inner}<ExternalLink className="w-3 h-3" /></a>;
  if (href.startsWith("#")) return <span className={cls}>{inner}</span>;
  return <Link to={href} className={cls}>{inner}</Link>;
};

export const Tools = () => (
  <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6" data-testid="manual-tools">
    <div className="grid sm:grid-cols-2 gap-4">
      {TOOLS.map(([g, links]) => (
        <div key={g} className="panel p-5"><p className="label-xs text-brand">{g}</p>
          <ul className="mt-3 space-y-2">{links.map(([l, h, n]) => <li key={l}><ToolLink l={l} href={h} note={n} /></li>)}</ul></div>
      ))}
    </div>
    <div className="panel p-5" data-testid="legal-checklist"><p className="label-xs text-brand">Legal review checklist · what a lawyer looks for</p>
      <ul className="mt-3 space-y-2 text-sm text-white/75">{LEGAL_CHECK.map((c) => <li key={c}>□ {c}</li>)}</ul>
      <p className="text-[11px] text-white/40 mt-4">General guidance, not legal advice.</p></div>
  </div>
);

export const MerchantFaq = ({ q = "" }) => {
  const list = MERCHANT_FAQ.filter(([k, v]) => !q || `${k} ${v}`.toLowerCase().includes(q));
  return (
    <dl className="grid md:grid-cols-2 gap-x-8 gap-y-5" data-testid="manual-merchant-faq">
      {list.map(([k, v], i) => <div key={k} className="border-l-2 border-brand pl-4" data-testid={`faq-item-${i}`}><dt className="font-bold">{k}</dt><dd className="text-sm text-white/65 mt-1">{v}</dd></div>)}
      {!list.length && <p className="text-sm text-white/45">No matching questions.</p>}
    </dl>
  );
};
